/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { ScheduleCheckUsageDialogComponent } from './schedule-check-usage-dialog.component';

export const scheduleCheckUsageDialogRoute = createDialogRoute({
  component: ScheduleCheckUsageDialogComponent,
});
